class ACountdownTimer {
  constructor(timerEl) {
    this.el = timerEl;
  }

  start() {
    // Save the intervalID so we can clear this interval when its time to
    // turn off the timer.
    this.intervalID = setInterval(() => {
      this.update();
    }, 1000);
    this.update();
  }

  update() {
    const endtime = this.el.dataset.countdownTo;
    const loopInterval = this.el.dataset.countdownLoop;

    // Turn off timer / loop if end_date is passed.
    const timeRemaining = this.getTimeRemaining(endtime);
    if (timeRemaining.total < 0) {
      if (loopInterval) {
        this.addLoopIntervalToEndDate();
        this.updateTimerDOM();
      } else {
        // Stop counting
        clearInterval(this.intervalID);
      }
    } else {
      this.updateTimerDOM();
    }
  }

  addLoopIntervalToEndDate() {
    const loopInterval = this.el.dataset.countdownLoop;
    const endtime = this.el.dataset.countdownTo;

    if (loopInterval) {
      let endDate = new Date(endtime);
      let timeRemaining = this.getTimeRemaining(endtime);

      // Used for error reporting
      let loopIndex = 0;

      // Add the loop interval under the time remaining is above 0 ms, and
      // caps the number of loops to 10000 just in case of date input error.
      while (timeRemaining.total < 0 && loopIndex < 10000) {
        endDate.setDate(
          endDate.getDate() + parseInt(loopInterval)
        );
        timeRemaining = this.getTimeRemaining(endDate.toString());
        loopIndex++;
      }
      this.el.dataset.countdownTo = endDate.toString();

      // Notify if we had to loop 10000 times
      if (loopIndex === 10000) {
        console.error('Warning: Added timer loop interval more than 10000 times');
      }
    }
  }

  updateTimerDOM() {
    const endtime = this.el.dataset.countdownTo;
    const t = this.getTimeRemaining(endtime);

    const dayBox = this.el.querySelector('[data-countdown-unit="day"]');
    const hrBox = this.el.querySelector('[data-countdown-unit="hour"]');
    const minBox = this.el.querySelector('[data-countdown-unit="min"]');
    const secBox = this.el.querySelector('[data-countdown-unit="sec"]');
    
    this.setNumberInBox(dayBox, t.days);
    this.setNumberInBox(hrBox, t.hours);
    this.setNumberInBox(minBox, t.minutes);
    this.setNumberInBox(secBox, t.seconds);
  }

  /**
   * Takes a date string (endtime) and outputs an object that has how
   * much time is remaining in it.
   */
  getTimeRemaining(endtime){
    const t = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor( (t/1000) % 60 );
    const minutes = Math.floor( (t/1000/60) % 60 );
    const hours = Math.floor( (t/(1000*60*60)) % 24 );
    const days = Math.floor( t/(1000*60*60*24) );
    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }

  setNumberInBox(box, num) {
    const numberElement = box.querySelector('.number');
    // If NaN is given, fallback to showing an empty box
    if (!Number.isNaN(num)) {
      numberElement.innerHTML = num;
    } else {
      numberElement.innerHTML = '';
    }
  }
}

class ACountdownBar {
  constructor() {
    this.initSwiper();
    this.initCountdownTimers();
  }

  initSwiper() {
    let slideSpeed = parseInt(window.ACountdownBarSettings.slide_speed);
    if (!slideSpeed) {
      slideSpeed = 3000;
    }
    this.swiper = new Swiper('.ACountdownBar__Swiper', {
      slidesPerView: 1,
      autoplay: {
        delay: slideSpeed,
      },
      threshold: 10,
      navigation: {
        nextEl: '.ACountdownBar__Nav .swiper-button-next',
        prevEl: '.ACountdownBar__Nav .swiper-button-prev',
      },
    });
  }

  initCountdownTimers() {
    const timers = document.querySelectorAll('.CountdownTimer');
    timers.forEach((timer) => {
      new ACountdownTimer(timer).start();
    });
  }
}

new ACountdownBar();